import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

export const masterRoleGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Verifica se o usuário está autenticado e tem token válido
  if (!authService.tokenIsValid()) {
    router.navigate(['/auth/login']);
    return false;
  }

  // Verifica se o usuário tem perfil MASTER
  if (!authService.isMasterUser()) {
    window.location.href = '/home'
    return false;
  }

  return true;
};